<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-2 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <!--Call-Text-->
  <div class="i-main-call mt-4 py-5 container">
    <div class="col text-center px-2 px-lg-5 pt-3 pb-4">
      MOVEMOS AS PESSOAS<br />
      PARA O SEU MELHOR LUGAR
    </div>
  </div>
  <!--About-Content-->
  <div class="i-about container pb-5">
    <div class="i-content row">
      <div class="i-subtitle col-12 col-lg-10 text-left mb-4 py-4 px-2 px-lg-5">
        ACREDITAMOS QUE O MELHOR LUGAR TEM O PODER DE ELEVAR O ESTADO EMOCIONAL, SEJA PARA MORAR OU
        <span>TR</span>ABALHAR. UMA VISTA INSPIRADORA, UMA LOCALIZA&Ccedil;&Atilde;O QUE FACILITE A VIDA OU UMA
        INFRAESTRUTURA QUE OFERE&Ccedil;A CONFORTO.
      </div>
      <div class="i-text text-justify pb-5 pt-2 col-12 col-lg-6 px-2 px-lg-5">
        <p>
          N&atilde;o &eacute; curioso que, enquanto todos falam em agilidade, em conex&atilde;o, em fronteiras cada vez
          mais fluidas, o mercado imobili&aacute;rio ainda fala em realizar sonhos e construir endere&ccedil;os?
        </p>
        <br />
        <p>
          N&oacute;s pensamos diferente. Entendemos a rela&ccedil;&atilde;o das pessoas com o tempo, o comportamento de
          conviver simultaneamente em m&uacute;ltiplos espa&ccedil;os. Trabalhamos em casa, moramos sem paredes, vivemos
          na rua.
        </p>
        <br />
        <p>
          Ainda que sejamos uma imobili&aacute;ria, imobilidade &eacute; um adjetivo que n&atilde;o nos descreve. Como
          nossos clientes, vivemos em constante movimento, aceleramos na velocidade da inova&ccedil;&atilde;o e pautamos
          nossas entregas com tecnologia, cuidado e aten&ccedil;&atilde;o.
        </p>
      </div>
      <div class="i-text text-justify pb-5 pt-2 col-12 col-lg-6 px-2 px-lg-5">
        <p>
          Essa &eacute; a nova din&acirc;mica da sociedade: estar em um lugar hoje, querer outro amanh&atilde;. Mudam as
          fam&iacute;lias, muda o trabalho&#8230; a gente muda junto, e tudo bem com isso.
        </p>
        <br />
        <p>
          &Eacute; mergulhando em relacionamentos personalizados e desenhando solu&ccedil;&otilde;es singulares que
          movemos as pessoas para o seu melhor lugar.
        </p>
        <br />
        <p>
          A prop&oacute;sito: trabalhamos com im&oacute;veis em bairros selecionados de Porto Alegre e S&atilde;o Paulo.
          Mas aquilo que nos move, de verdade, &eacute; encontrar as melhores op&ccedil;&otilde;es para seu
          investimento, os lugares mais produtivos para sua empresa e os lares que melhor traduzem sua personalidade.
          Isso &eacute; ser Private!
        </p>
        <br />
      </div>
    </div>
    <!--Pictures-->
    <div class="i-pitcures row">
      <div class="col-12 col-lg-6 pb-4 pt-2 px-2 px-lg-5">
        <img class="img-fluid w-100" src="assets/img/trade24.jpg" alt="Prédio" />
      </div>
      <div class="i-thumbs col-12 col-lg-6 pb-4 pt-2 px-2 px-lg-5">
        <div class="d-flex flex-row flex-wrap">
          <div class="col-6 px-0">
            <a href="#lightBox" data-toggle="modal">
              <img
                class="img-fluid w-100 pb-3 pr-2"
                lazyLoad="assets/img/fotos/01.jpg"
                style="height: 11.5rem"
                alt="Foto 01" />
            </a>
            <a href="#lightBox" data-toggle="modal">
              <img
                class="img-fluid w-100 pr-2"
                lazyLoad="assets/img/fotos/02.jpg"
                style="height: 11.5rem"
                alt="Foto 02" />
            </a>
          </div>
          <div class="col-6 px-0">
            <a href="#lightBox" data-toggle="modal">
              <img
                class="img-fluid w-100 pb-3 pl-2"
                lazyLoad="assets/img/fotos/03.jpg"
                style="height: 11.5rem"
                alt="Foto 03" />
            </a>
            <a href="#lightBox" data-toggle="modal">
              <img
                class="img-fluid w-100 pl-2"
                lazyLoad="assets/img/fotos/04.jpg"
                style="height: 11.5rem"
                alt="Foto 04" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--LightBox-->
    <div class="modal fade" id="lightBox" tabindex="-1" role="dialog" aria-labelledby="lightBox" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div id="lightBoxControls" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="d-block w-100" src="assets/img/fotos/01.jpg" alt="Foto 01" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/02.jpg" alt="Foto 02" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/03.jpg" alt="Foto 03" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/04.jpg" alt="Foto 04" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/05.jpg" alt="Foto 05" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/06.jpg" alt="Foto 06" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/07.jpg" alt="Foto 07" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/08.jpg" alt="Foto 08" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/09.jpg" alt="Foto 09" />
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="assets/img/fotos/10.jpg" alt="Foto 10" />
                </div>
              </div>
              <a
                class="carousel-control-prev"
                href="#lightBoxControls"
                role="button"
                data-slide="prev"
                aria-label="Nav.esquerda">
                <img src="assets/img/btn_nav_esquerda.png" width="17px" height="70px" alt="Nav.esquerda" />
              </a>
              <a
                class="carousel-control-next"
                href="#lightBoxControls"
                role="button"
                data-slide="next"
                aria-label="Nav.direita">
                <img src="assets/img/btn_nav_direita.png" width="17px" height="70px" alt="Nav.direita" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Values-->
  <div class="i-values">
    <div class="container">
      <div class="i-section row py-5">
        <div class="i-title col-12 text-center py-3 px-2 px-lg-5">NOSSA PROPOSTA<br />DE VALOR</div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 pt-3">
          <div class="i-subtitle text-left py-4 pr-5">AS MELHORES <br />PESSOAS</div>
          <p class="i-text">
            Reunimos um time de grandes talentos e investimos no desenvolvimento das pessoas para que cuidem com
            maestria dos neg&oacute;cios de nossos clientes.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 pt-3">
          <div class="i-subtitle text-left py-4 pr-5">ENCANTAMENTO <br />NO ATENDIMENTO</div>
          <p class="i-text">
            Desenvolvemos um m&eacute;todo para compreender profundamente cada cliente e guiar a jornada
            imobili&aacute;ria com efici&ecirc;ncia, transpar&ecirc;ncia e organiza&ccedil;&atilde;o, visando
            relacionamentos de longo prazo.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 pt-3">
          <div class="i-subtitle text-left py-4 pr-5">CURADORIA <br />IMOBILI&Aacute;RIA</div>
          <p class="i-text">
            Selecionamos im&oacute;veis de qualidade com liquidez, potencial de valoriza&ccedil;&atilde;o e
            localiza&ccedil;&atilde;o privilegiada que configuram excelentes oportunidades de neg&oacute;cio.
          </p>
          <br />
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <!--Services-->
    <div class="i-section row pt-5">
      <div class="col-12 col-lg-6 pb-5 pt-2 px-2 px-lg-5">
        <div class="i-title text-center py-4">VENDAS E <br />LOCA&Ccedil;&Otilde;ES</div>
        <div class="i-text text-justify">
          Tanto para vendas quanto para loca&ccedil;&atilde;o de im&oacute;veis, nosso principal objetivo &eacute; gerar
          valor. Hoje, com tantas informa&ccedil;&otilde;es dispon&iacute;veis na internet, o cliente precisa sentir-se
          seguro com a sua negocia&ccedil;&atilde;o. &Eacute; crucial neste momento um especialista em quem ele possa
          confiar, expor seus anseios, d&uacute;vidas ou at&eacute; mesmo obter uma consultoria, proporcionando economia
          de tempo e valoriza&ccedil;&atilde;o com seu capital dispon&iacute;vel, resultando no melhor neg&oacute;cio
          com o menor investimento poss&iacute;vel.
        </div>
        <br />
      </div>
      <div class="col-12 col-lg-6 pb-5 pt-2 px-2 px-lg-5">
        <div class="i-title text-center py-4">SUPORTE <br />JUR&Iacute;DICO</div>
        <div class="i-text text-justify">
          Todas as etapas da jornada t&ecirc;m atua&ccedil;&atilde;o de excel&ecirc;ncia por nossa equipe. Um corpo
          jur&iacute;dico &eacute; fundamental quando buscamos obter grandes resultados, trazendo ao cliente mais
          agilidade, responsabilidade e sigilo. Al&eacute;m da especializa&ccedil;&atilde;o em direito
          imobili&aacute;rio, acompanhamos 100% do tramite de sua assinatura at&eacute; o registro do im&oacute;vel,
          tudo isso para tornar a experi&ecirc;ncia da jornada algo mais tranquilo para o comprador e vendedor.
        </div>
        <br />
      </div>
    </div>
    <!--Prêmios-->
    <div class="i-section row pb-3">
      <div class="i-title col-12 text-center mb-5 py-4 px-2 px-lg-5">RECONHECIMENTO E PREMIAÇÕES</div>
      <div class="col-12 pb-5">
        <app-awards></app-awards>
      </div>
    </div>
    <!--Team-->
    <div class="i-section row">
      <div class="i-title col-12 text-center mb-5 py-4 px-2 px-lg-5">NOSSA EQUIPE</div>
      <div class="col-12 d-flex flex-wrap justify-content-around justify-content-lg-between px-0">
        <div *ngFor="let broker of (brokers$ | async)?.diretores" class="i-member text-center pb-3 mb-4 px-2 px-lg-5">
          <div class="i-photo">
            <img *ngIf="broker.fotoUrl" class="img-fluid mx-auto" [src]="broker?.fotoUrl" [alt]="broker?.nome" />
          </div>
          <div class="i-text i-name pt-3">{{ broker?.nome }}</div>
          <div class="i-text i-role pt-1">S&oacute;cio Diretor</div>
          <a class="i-text pt-1" href="tel:+555132762040">51 3276 2040</a>
        </div>
      </div>
      <div class="col-12 d-flex flex-wrap justify-content-around justify-content-lg-between px-0">
        <ng-container *ngFor="let broker of (brokers$ | async)?.corretores">
          <div *ngIf="broker.fotoUrl" class="i-member text-center pb-3 mb-4 px-2 px-lg-5">
            <div class="i-photo">
              <a
                [href]="(broker.creciSlug ? broker.url : 'javascript:void(0)') | safe"
                [attr.target]="broker.creciSlug ? '_blank' : '_self'">
                <img *ngIf="broker.fotoUrl" class="img-fluid mx-auto" [lazyLoad]="broker.fotoUrl" alt="" />
              </a>
            </div>
            <!--
                        <div class="i-text i-name pt-3">{{ broker?.nome }}</div>
                        <a href="tel:+55{{formatPhone(broker)}}"
                           class="i-text pt-1">{{ broker?.celular ? broker?.celular : broker.fone }}</a>
                        -->
          </div>
        </ng-container>
        <!-- outros membros / não corretores -->
        <ng-container *ngFor="let member of team$ | async">
          <div *ngIf="member.fotoUrl" class="i-member text-center pb-3 mb-4 px-2 px-lg-5">
            <div class="i-photo">
              <img *ngIf="member.fotoUrl" class="img-fluid mx-auto" [lazyLoad]="member.fotoUrl" alt="" />
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <!--Old-->
    <div class="i-section row pt-3 pb-5">
      <!--Aside-->
      <div class="i-aside col-12 col-lg-4 pb-5">
        <!--<ul *ngIf="pages" class="nav d-flex flex-column">
                    <li *ngFor="let p of pages" class="nav-item">
                        <a class="i-text nav-link pl-0 pb-3" routerLinkActive="active"
                           [routerLink]="baseURL + p.slug">{{p.menu | uppercase}}</a>
                        <ul *ngIf="p.filhasAtivas?.length > 0" class="i-sub-item">
                            <li *ngFor="let pf of p.filhasAtivas" class="nav-item pl-3">
                                <a class="i-text nav-link pl-0 pb-3" routerLinkActive="active"
                                   [routerLink]="baseURL + pf.slug">{{pf.menu | uppercase}}</a>
                            </li>
                        </ul>
                    </li>
                </ul>-->
      </div>
      <!--Main-Content-->
      <div class="i-content col-12 col-lg-8">
        <!--<div *ngIf="page.titulo" class="i-title text-left pt-2 pb-5">{{page.titulo}}</div>
                <div class="pb-5 i-text" [innerHTML]="page.conteudo | html"></div>
                <div *ngIf="page?.anexos?.length > 0" class="col-12 py-3">
                    <b>Anexos</b>
                    <ul class="i-attachments mt-2">
                        <li *ngFor="let a of page.anexos" class="pb-2">
                            <div [class]="'i-file i-file-' + a.tipoCSS">
                                <a [href]="a.arquivoURL" target="_blank" [title]="a.descricao">{{a.titulo}}</a>
                            </div>
                        </li>
                    </ul>
                </div>-->
      </div>
    </div>
  </div>
</div>
